import selectorEscape from '../../../lib/selector_escape';

$(() => {
  $('.js-validate-form-recruit-page').validate({
    rules: {
      'recruit_page[subdomain]': {
        required: true,
      },
      'recruit_page[name]': {
        required: true,
      },
      'recruit_page[logo_text]': {
        required: `input[type=checkbox][name=${selectorEscape('recruit_page[use_logo_image]')}]:not(:checked)`,
      },
    },

    errorPlacement(error, element) {
      const target = element.attr('name');
      if (target !== 'recruit_page[subdomain]') {
        error.insertAfter(element);
      }
    },
  });
});
